// extracted by css-extract-rspack-plugin
export default {"root":"InlineFlagCell_root__6yYvL","text":"InlineFlagCell_text__grvEv"};